import { TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityHistory } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { Task } from '@skinsoft/types';
import { toHistoryRecord$ } from '../../serializer/history';

@Component({
    components: {
        sEntityHistory: EntityHistory,
    },
    props: ['targetRouteName'],
    template: require('./task-history.html'),
})
export class TaskHistory extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public historyStates = TaskDataStore.historyStates;
    public serializer = (task: Task) => toHistoryRecord$(task, this.$i18n.locale);
    public sortFields = TaskDataStore.sortFields;
    public targetRouteName;
}
